export const REDUCER_KEY_LINK_OPTIONS = 'linkOption';

export const LINK_OPTIONS_OPEN = 'rs/LinkOptions/LINK_OPTIONS_OPEN';
export const LINK_OPTIONS_CLOSE = 'rs/LinkOptions/LINK_OPTIONS_CLOSE';
export const LINK_OPTIONS_CLEAR = 'rs/LinkOptions/LINK_OPTIONS_CLEAR';
export const LINK_OPTION_CHECKED = 'rs/LinkOptions/LINK_OPTION_CHECKED';
export const LINK_OPTION_COPY_REACTION_FAILURE = 'rs/LinkOptions/LINK_OPTION_COPY_REACTION_FAILURE';

export class LinkOptionType {
  static SHOW_CONDITIONS = 'LinkOptionType.SHOW_CONDITIONS';

  static ADD_REACTION_STEP = 'LinkOptionType.ADD_REACTION_STEP';

  static HIDE_PRIOR_STEPS = 'LinkOptionType.HIDE_PRIOR_STEPS';

  static DELETE_PRIOR_STEPS = 'LinkOptionType.DELETE_PRIOR_STEPS';

  static COPY_REACTION = 'LinkOptionType.COPY_REACTION';

  static EXPLORE_CONDITIONS = 'LinkOptionType.EXPLORE_CONDITIONS';

  static get allTypes() {
    return [
      LinkOptionType.SHOW_CONDITIONS,
      LinkOptionType.ADD_REACTION_STEP,
      LinkOptionType.HIDE_PRIOR_STEPS,
      LinkOptionType.DELETE_PRIOR_STEPS,
      LinkOptionType.COPY_REACTION,
      LinkOptionType.EXPLORE_CONDITIONS,
    ];
  }
}
